module.exports = __webpack_public_path__ + "static/media/countries.5877685d.jpg";